import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import "../../../feature-styles/auth.css";
import {

    FaUser,
    FaLock,
    FaShieldAlt,
    FaSignInAlt,
    FaEye,
    FaEyeSlash

} from "react-icons/fa";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import RecoveryPasswordModal from "../components/RecoveryPassword/RecoveryPasswordModal";
import { authApi } from "../../auth/api/auth.api";
import { useAuth } from "../../../context/AuthContext";
import { loginSchema } from "../../auth/schemas/login.schema";
import { toast } from "react-hot-toast";
import { TOAST_ERROR_IDS } from '../../../interaces/toast.ids.interface';
export default function Login() {
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: zodResolver(loginSchema)
    })
    const navigate = useNavigate();
    const { login } = useAuth();
    const [obscure, setObscure] = useState(true);
    const [loading, setLoading] = useState(false);
    const [openRecover, setOpenRecover] = useState(false);
    const onSubmit = async (data) => {
        setLoading(true);
        try {
            data.password=data.password.trim()
            data.username=data.username.trim()
            const response = await authApi.login(data)
            login({
                username: response.username,
                role: response.role,
                fullName: response.fullName,
                privileges: response.privileges || []
            }, response.token);
            
            navigate('/home');
        } catch (error) {
            toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, { id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR });
            setLoading(false);
        }
    };
    return (
        <div className="main-div login-screen">
            <main className="secondary-div login-panel">
                <header className="panel-header login-header">
                    <div className="login-brand">
                        <span className="login-brand-mark" aria-hidden="true">
                            <FaShieldAlt />
                        </span>
                        <div className="login-brand-copy">
                            <span className="login-brand-kicker">Servicios digitales</span>
                            <h1 className="panel-header-title">
                                PLATAFORMA ESTATAL DE INTEROPERABILIDAD E IDENTIFICACIÓN DIGITAL
                            </h1>
                        </div>
                    </div>
                </header>
                <section className="panel-body login-body">
                    <div className="login-intro">
                        <span className="login-eyebrow">Acceso seguro</span>
                        <h2 className="h2-title">Acceso con credenciales</h2>
                        <p className="login-description">Ingrese sus datos para continuar</p>
                    </div>
                    <form className="form-modal login-form" onSubmit={handleSubmit(onSubmit)}>
                        <label className="label-input login-label" htmlFor="login-username">
                            Usuario
                        </label>
                        <div className="input-inline-login">
                            <FaUser className="icon-input" aria-hidden="true" />
                            <input
                                id="login-username"
                                className="input-plain-login"
                                type="text"
                                autoComplete="username"
                                placeholder="Ingrese el nombre de usuario"
                                aria-invalid={Boolean(errors.username)}
                                aria-describedby={errors.username ? "login-username-error" : undefined}
                                {...register("username")}
                            />
                        </div>
                        <div className="text-start">
                            {errors.username && (
                                <span id="login-username-error" className="span-error-form">
                                    {errors.username.message}
                                </span>
                            )}
                        </div>
                        <label className="label-input login-label" htmlFor="login-password">
                            Contraseña
                        </label>
                        <div className="password-inline-login">
                            <FaLock className="icon-input" aria-hidden="true" />
                            <input
                                id="login-password"
                                className="input-plain-login"
                                type={obscure ? "password" : "text"}
                                autoComplete="current-password"
                                placeholder="Ingrese su contraseña"
                                aria-invalid={Boolean(errors.password)}
                                aria-describedby={errors.password ? "login-password-error" : undefined}
                                {...register("password")}
                            />
                            <button
                                type="button"
                                onClick={() => setObscure(!obscure)}
                                className="eye-toggle"
                                aria-label={obscure ? "Mostrar contraseña" : "Ocultar contraseña"}
                                aria-pressed={!obscure}
                            >
                                {obscure ? <FaEyeSlash aria-hidden="true" /> : <FaEye aria-hidden="true" />}
                            </button>
                        </div>
                        <div className="text-start">
                            {errors.password && (
                                <span id="login-password-error" className="span-error-form">
                                    {errors.password.message}
                                </span>
                            )}
                        </div>
                        <div className="div-link-recovery-password login-recovery-row">
                            <button type="button" onClick={() => setOpenRecover(true)} className="forgot-button">
                                ¿Olvidó su contraseña?
                            </button>
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="btn-access login-submit"
                        >
                           
                            {loading ? "Verificando..." : "ACCEDER"}
                        </button>
                    </form>
                </section>
                {openRecover && (
                    <RecoveryPasswordModal
                        open={openRecover}
                        onClose={() => setOpenRecover(false)}
                    />
                )}
                <div className="fixed bottom-4 right-4">
                    <h3>Versión: 1.0.0</h3>
                </div>
            </main>
        </div>
    );

}
